"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEMScenes = void 0;
var AEMScenes;
(function (AEMScenes) {
    AEMScenes["ABTESTING"] = "AEMScenes_ABTesting";
    AEMScenes["ACCOUNT_ACTIVATION"] = "AEMScenes_AccountActivation";
    AEMScenes["ACCOUNT_CREDIT_CARD"] = "AEMScenes_AccountCreditCard";
    AEMScenes["ACCOUNT_DELIVERY_ADDRESSES"] = "AEMScenes_AccountDeliveryAddresses";
    AEMScenes["ACCOUNT_MENU"] = "AEMScenes_AccountMenu";
    AEMScenes["ACCOUNT_MENU_ITEM"] = "AEMScenes_AccountMenuItem";
    AEMScenes["ACCOUNT_ORDER_HISTORY"] = "AEMScenes_AccountOrderHistory";
    AEMScenes["ACCOUNT_OVERVIEW_INFO"] = "AEMScenes_AccountOverview_info";
    AEMScenes["ACCOUNT_PASSWORD_RESET"] = "AEMScenes_AccountPasswordReset";
    AEMScenes["ACCOUNT_PAYBACK_ENRICHMENT"] = "AEMScenes_AccountPaybackEnrichment";
    AEMScenes["ACCOUNT_PREFERENCES"] = "AEMScenes_AccountPreferences";
    AEMScenes["ACCOUNT_PROFILE_DETAILS"] = "AEMScenes_AccountProfileDetails";
    AEMScenes["ACCOUNT_REGISTRATION"] = "AEMScenes_AccountRegistration";
    AEMScenes["ACCOUNT_UNSUBSCRIBE"] = "AEMScenes_AccountUnsubscribe";
    AEMScenes["ACCOUNT_VOUCHERS"] = "AEMScenes_AccountVouchers";
    AEMScenes["BASKET_MENU_ITEM"] = "AEMScenes_BasketMenuItem";
    AEMScenes["BASKET_OVERVIEW"] = "AEMScenes_BasketOverview";
    AEMScenes["BASKET_OVERVIEW_V2"] = "AEMScenes_BasketOverview_v2";
    AEMScenes["BASKET_PERSONAL_SHOPPING_ADVICE"] = "AEMScenes_BasketPersonalShoppingAdvice";
    AEMScenes["BOXED_TITLE"] = "AEMScenes_BoxedTitle";
    AEMScenes["BRAND_TILE_LISTER"] = "AEMScenes_BrandTileLister";
    AEMScenes["BREADCRUMB"] = "AEMScenes_Breadcrumb";
    AEMScenes["BUY"] = "AEMScenes_Buy";
    AEMScenes["BUY_CONFIRMATION"] = "AEMScenes_BuyConfirmation";
    AEMScenes["BUY_PAYMENT_REQUEST"] = "AEMScenes_BuyPaymentRequest";
    AEMScenes["BUY_PAYMENT_REQUEST_CONFIRMATION"] = "AEMScenes_BuyPaymentRequestConfirmation";
    AEMScenes["CAMPAIGN_GROUP"] = "AEMScenes_CampaignGroup";
    AEMScenes["CATEGORY_TILE"] = "AEMScenes_CategoryTile";
    AEMScenes["CHANGE_PASSWORD"] = "AEMScenes_ChangePassword";
    AEMScenes["CHECKOUT"] = "AEMScenes_Checkout";
    AEMScenes["CHECKOUT_HEADER"] = "AEMScenes_CheckoutHeader";
    AEMScenes["COLLAPSIBLE_LIST"] = "AEMScenes_CollapsibleList";
    AEMScenes["CONTENT_TILE_LISTER"] = "AEMScenes_ContentTileLister";
    AEMScenes["CONTENT_DETAIL_HEADER"] = "AEMScenes_ContentDetailHeader";
    AEMScenes["COOKIE_MESSAGE"] = "AEMScenes_CookieMessage";
    AEMScenes["COUNTDOWN"] = "AEMScenes_Countdown";
    AEMScenes["CURRENCY_MENU_ITEM"] = "AEMScenes_CurrencyMenuItem";
    AEMScenes["DELIVERY_CONDITIONS_BANNER"] = "AEMScenes_DeliveryConditionsBanner";
    AEMScenes["DISTINCTIVE_PRODUCT_DETAILS"] = "AEMScenes_DistinctiveProductDetails";
    AEMScenes["DPE_ACTIVATOR"] = "AEMScenes_DpeActivatorContainer";
    AEMScenes["ESSENTIALS"] = "AEMScenes_Essentials";
    AEMScenes["ETICKET"] = "AEMScenes_Eticket";
    AEMScenes["FEEFO_BRAND_BADGE"] = "AEMScenes_FeefoBrandBadge";
    AEMScenes["FOLDER_NAVIGATION"] = "AEMScenes_FolderNavigation";
    AEMScenes["GIFT_VOUCHER"] = "AEMScenes_GiftVoucher";
    AEMScenes["GLOSSARY"] = "AEMScenes_Glossary";
    AEMScenes["GUEST_REDIRECT"] = "AEMScenes_GuestRedirect";
    AEMScenes["LANGUAGE_MENU_ITEM"] = "AEMScenes_LanguageMenuItem";
    AEMScenes["LINE"] = "AEMScenes_Line";
    AEMScenes["LIST"] = "AEMScenes_List";
    AEMScenes["LOGIN"] = "AEMScenes_Login";
    AEMScenes["MOBILE_NAVIGATION"] = "AEMScenes_MobileNavigation";
    AEMScenes["MONETATE"] = "AEMScenes_Monetate";
    AEMScenes["NEWSLETTER_SUBSCRIBE"] = "AEMScenes_NewsletterSubscribe";
    AEMScenes["ORDER_OVERVIEW"] = "AEMScenes_OrderOverview";
    AEMScenes["PRODUCT_COMPARISON"] = "AEMScenes_ProductComparison";
    AEMScenes["PRODUCT_CONTENT_VIDEO"] = "AEMScenes_ProductContentVideo";
    AEMScenes["PRODUCT_DETAIL_V2"] = "AEMScenes_ProductDetail_v2";
    AEMScenes["PRODUCT_GROUP"] = "AEMScenes_ProductGroup";
    AEMScenes["PRODUCT_GROUP_FREDHOPPER"] = "AEMScenes_ProductGroupFredhopper";
    AEMScenes["PRODUCT_GROUP_MONETATE"] = "AEMScenes_ProductGroupMonetate";
    AEMScenes["PRODUCT_GROUP_PDP_COMPARISON_FREDHOPPER"] = "AEMScenes_ProductGroupPdpComparisonFredhopper";
    AEMScenes["PRODUCT_GROUP_PDP_COMPARISON_MONETATE"] = "AEMScenes_ProductGroupPdpComparisonMonetate";
    AEMScenes["PRODUCT_INSPIRATION"] = "AEMScenes_ProductInspiration";
    AEMScenes["PRODUCT_LISTER"] = "AEMScenes_ProductLister";
    AEMScenes["PRODUCT_RECENTLY_VIEWED"] = "AEMScenes_ProductRecentlyViewed";
    AEMScenes["PRODUCT_RELEVANT_CONTENT"] = "AEMScenes_ProductRelevantContent";
    AEMScenes["PRODUCT_REVIEW"] = "AEMScenes_ProductReview";
    AEMScenes["PRODUCT_REVIEW_LANDING"] = "AEMScenes_ProductReviewLanding";
    AEMScenes["PRODUCT_TOP_FIVE"] = "AEMScene_ProductTopFive";
    AEMScenes["PRODUCT_WIZARD"] = "AEMScenes_ProductWizard";
    AEMScenes["RECENTLY_OPENED_STORES"] = "AEMScenes_RecentlyOpenedStores";
    AEMScenes["REEVOO_CUSTOMER_EXPERIENCE"] = "AEMScenes_ReevooCustomerExperience";
    AEMScenes["REGISTRATION_COMPACT"] = "AEMScenes_RegistrationCompact";
    AEMScenes["RELATED_CATEGORIES"] = "AEMScenes_RelatedCategories";
    AEMScenes["RENTAL"] = "AEMScenes_Rental";
    AEMScenes["RETURN_ITEMS"] = "AEMScenes_ReturnItems";
    AEMScenes["RETURN_PORTAL_LOGIN"] = "AEMScenes_ReturnPortalLogin";
    AEMScenes["SEARCH_MENU_ITEM"] = "AEMScenes_SearchMenuItem";
    AEMScenes["AUTHOR_DATA"] = "AEMScenes_AuthorData";
    AEMScenes["AUTHOR_INFORMATION"] = "AEMScenes_AuthorInformation";
    AEMScenes["AUTHOR_LINKED_CONTENT_PAGES"] = "AEMScenes_AuthorLinkedContentPages";
    AEMScenes["AUTHOR_LINKED_PRODUCTS"] = "AEMScenes_AuthorLinkedProducts";
    AEMScenes["SERVICE_ORDER_TRACKING"] = "AEMScenes_ServiceOrderTracking";
    AEMScenes["SHOPPING_BUDGET"] = "AEMScenes_ShoppingBudget";
    AEMScenes["SHOP_NUMBER"] = "AEMScenes_ShopNumber";
    AEMScenes["SHOP_THE_LOOK"] = "AEMScenes_ShopTheLook";
    AEMScenes["SINGLE_PRODUCT_TILE"] = "AEMScenes_SingleProductTile";
    AEMScenes["SLIDER"] = "AEMScenes_Slider";
    AEMScenes["SOCIAL_LINKS"] = "AEMScenes_SocialLinks";
    AEMScenes["STORE_DEPARTMENTS"] = "AEMScenes_StoreDepartments";
    AEMScenes["STORE_GENERAL"] = "AEMScenes_StoreGeneral";
    AEMScenes["STORE_LOCATOR"] = "AEMScenes_StoreLocator";
    AEMScenes["STORE_NEARBY_STORES"] = "AEMScenes_StoreNearbyStores";
    AEMScenes["TEASER"] = "AEMScenes_Teaser";
    AEMScenes["VIDEO"] = "AEMScenes_Video";
    AEMScenes["VOUCHER"] = "AEMScenes_Voucher";
    AEMScenes["WISHLIST"] = "AEMScenes_Wishlist";
    AEMScenes["WISHLIST_MENU_ITEM"] = "AEMScenes_WishlistMenuItem";
    AEMScenes["ZITCHA_BANNER"] = "AEMScenes_ZitchBanner";
})(AEMScenes || (exports.AEMScenes = AEMScenes = {}));
//# sourceMappingURL=HypernovaRenderTypes.js.map